import bootstrap from 'bootstrap.native/src/index-v4';
import * as Sentry from '@sentry/browser';
import "../css/app.scss";
import request from "./_components/Routes/request_handler";

for(let row of document.querySelectorAll("tr.row-clickable")) {
    row.onclick = () => window.location = row.dataset.href;
    for(let cell of row.cells) {
        if(cell.children.length === 0) {
            cell.innerHTML = `<a class="row-link" href="${row.dataset.href}">${cell.innerHTML}</a>`;
        }
    }
}

window.addFlashMessage = (message, alertClass) => {
    const alertDiv = document.createElement("div");
    alertDiv.className = `alert alert-${alertClass} alert-dismissable fade show`;
    alertDiv.role = "alert";
    alertDiv.innerHTML = `${message} 
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>`;
    document.getElementById("flash-message-container").appendChild(alertDiv);
    new bootstrap.Alert(alertDiv);
};

if (window.ENABLE_SENTRY) {
    Sentry.init({
                dsn: window.SENTRY_DSN,
                release: window.SENTRY_APP_VERSION
            });
}

// FEEDBACK
document.querySelector("#feedback-submit").onclick = (e) => {
    e.preventDefault();
    document.querySelector("#feedback-form").classList.add("was-validated");
    document.querySelector("#feedback-message-group").classList.remove("is-valid");
    document.querySelector("#feedback-message-group").classList.remove("is-invalid");
    const message = document.querySelector("#feedback-message").value;
    if(message === "") {
        document.querySelector("#feedback-message-group").classList.add("is-invalid");
        return;
    }
    document.querySelector("#feedback-message-group").classList.add("is-valid");
    document.querySelector("#feedback-message").disabled = true;
    document.querySelector("#feedback-submit").disabled = true;

    const data = {
        url: window.location.href,
        message
    }
    request("/api/feedback", {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(data)
    }).then(
        (data) => {
            console.log(data); 
            document.querySelector("#feedback-form").innerHTML = `<div class="alert alert-success" role="alert">${data['message']}</div>`},
        (data) => {
            alert("An error occurred while submitting your feedback. Please send an email to the admins" +
            ` directly. We apologize for the inconvenience. (Message: ${data['message']})`)}
    );
};

window.bootstrap = bootstrap;
window.Sentry = Sentry;